var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2465 4.6356C13.1623 4.5374 13.0736 4.44233 12.9805 4.3507L10.7786 2.15661C10.1074 1.48784 9.02173 1.48784 8.35055 2.15661L6.1373 4.36192C5.25671 5.23935 4.75188 6.43691 4.75188 7.6844V12.2208H3.30255C2.89545 12.2208 2.56543 12.5508 2.56543 12.9579C2.56543 13.365 2.89545 13.695 3.30255 13.695H15.8286C16.2357 13.695 16.5657 13.365 16.5657 12.9579C16.5657 12.5508 16.2357 12.2208 15.8286 12.2208H14.3676V9.30589L12.8933 10.8523V12.2208H6.22613V7.6844C6.22613 6.83406 6.57118 6.01077 7.17788 5.40625L9.39112 3.20093C9.48701 3.10539 9.6421 3.10539 9.73798 3.20093L11.9416 5.39663L11.945 5.39997C12.0401 5.49352 12.1286 5.59241 12.2102 5.69594L13.2465 4.6356ZM7.7745 14.5456C7.7745 15.5368 8.58574 16.3452 9.58049 16.3452C10.5752 16.3452 11.3865 15.5368 11.3865 14.5456H10.4036H8.75733H7.7745Z",
    fill: "#26445A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0788 3.74195C17.3699 4.0265 17.3752 4.49319 17.0907 4.78433L10.9727 11.0441L8.02784 8.03103C7.74329 7.73989 7.74863 7.2732 8.03977 6.98865C8.33091 6.7041 8.7976 6.70945 9.08215 7.00059L10.9727 8.9349L16.0364 3.75388C16.3209 3.46274 16.7876 3.4574 17.0788 3.74195Z",
    fill: "#26445A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.52bf15111513bddb6e064b8786fbaf3f.svg";
export { ForwardRef as ReactComponent };